import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { customFields } from '../models/custom-fields/custom-fields';

@Component({
  selector: 'app-entertainment-details',
  templateUrl: './entertainment-details.component.html',
  styleUrls: ['./entertainment-details.component.scss']
})
export class EntertainmentDetailsComponent {
  @Input() visible = false;
  @Input() isEditable = true;
  @Input() customFields: customFields[];
  @Input() formId: number;
  @Input() formName: string;
  @Input() assignToUserName: string;
  @Input() taskId: string;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() saved = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
  }

  get attendees() {
    return this.form.get('attendees') as FormArray;
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onSubmit() {
    this.saved.emit({formId: this.formId, customFields: this.customFields});
    this.close();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
